module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.ea3d65a7.woff";